import React from "react";
import { StaticQuery, graphql } from "gatsby";
import SelectAwardYear from "./SelectAwardYear.js";
import {
  Row, Col } from "reactstrap";
import remark from 'remark';
import recommended from 'remark-preset-lint-recommended';
import remarkHtml from 'remark-html';
import module from '../../gatsby-config.js';
var externalLinks = require('remark-external-links');


export class AwardSelector extends React.Component {
  constructor(props){
    super(props);

    const data = props.data.allMarkdownRemark.edges;
    const yearList = this.getYears(props.data.allMarkdownRemark.edges).reverse();
    //garbage - convert string to int back to string.
    const currentYear = yearList.map(function(item){return parseInt(item, 10)}).sort()[yearList.length - 1].toString();
    const currentYearData = data.filter( entry =>
      { return entry.node.frontmatter.title === currentYear }
    )[0].node.frontmatter

    this.state = {
      data: data,
      years: yearList,
      currentYear: currentYear,
      currentYearData: currentYearData,
    }

    this.getYearData = this.getYearData.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.updateYear = this.updateYear.bind(this);
    this.getYears = this.getYears.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.buildAwardDisplay = this.buildAwardDisplay.bind(this);

  }

  getYearData(year){
    return this.state.data.filter( entry =>
      { return entry.node.frontmatter.title === year }
    )[0].node.frontmatter
  }

  componentDidMount(nextProps, nextState){
    this.updateYear(this.state.currentYear);
  }

  updateYear(year){
    const yearData = this.getYearData(year)
    const renderedAwards = this.buildAwardDisplay(year, yearData.awards)
    const renderedProgram = this.buildProgramDisplay(year, yearData.program)
    this.setState({
      currentYear: year,
      currentYearData: yearData,
      renderedAwards: renderedAwards,
      renderedProgram: renderedProgram
    });
  }

  getYears(data){
    var years = [];
    data.forEach(function(record){
      years.push(record.node.frontmatter.title);
    });
    return years;
  }

  handleSelectChange(e){
    e.preventDefault();
    this.updateYear(e.target.value);
  }

  buildProgramDisplay(year, program){
    if(program.includes('/')){
      return(
          <p><a href={program} target="_blank" rel="noopener noreferrer">View the {year} conference program here.</a></p>
      )
    }
    else{
      return(
          <p>No program available for {year}.</p>
      )
    }
  }

  buildAwardDisplay(year, awards){
    if(awards){
      return awards.map((award, index) =>
       (
        <div>
          <h3 dangerouslySetInnerHTML={{ __html: remark().use(externalLinks, {target: "_blank", rel: ['nofollow', 'noopener', 'noreferrer']}).use(recommended).use(remarkHtml).processSync(year + ' ' + award.award_title).toString() }}></h3>
          {award.winner_desc ? <p dangerouslySetInnerHTML={{ __html: remark().use(externalLinks, {target: "_blank", rel: ['nofollow', 'noopener', 'noreferrer']}).use(recommended).use(remarkHtml).processSync(award.winner_desc).toString() }}></p> : <span></span> }
          <h4>Awarded to: </h4>
          <ul>
            {award.winners.map((contributor, c_index) =>
              contributor.contributor_location ? (<li key={c_index}>{contributor.contributor_name}, {contributor.contributor_location}</li>) : (<li key={c_index}>{contributor.contributor_name}</li>)
            )}
          </ul>
          <hr />
        </div>
      ))
    }
    else{
      return (
        <div>
          <h3>No awards were presented in {year}.</h3>
        </div>
      )
    }
  }

  render(){
    return(
      <>
        <header>
          <h1>Conference Archives – {this.state.currentYear}</h1>
        </header>
        <Row style={{margin:`auto`}}>
            <SelectAwardYear years={this.state.years} handleClick={this.handleSelectChange.bind(this)} />
            <Col md="2">
              <img src={module.pathPrefix + this.state.currentYearData.image} alt={this.state.currentYearData.program_alt} style={{maxHeight:`200px`,maxWidth:`200px`}} />
            </Col>
            <Col md="9" sm="9">
              <h2>{this.state.currentYearData.number} Conference</h2>
              <p>Hosted by {this.state.currentYearData.host}, {this.state.currentYearData.dates}</p>
              <p>Theme: <em>{this.state.currentYearData.theme}</em></p>
              {this.state.renderedProgram}
            </Col>
          </Row>
          <hr style={{height:"1px",border:"none",width:"100%", background: "#000", textAlign:"center",margin:"15px"}}/>
          <Row>
            <Col lg="12">{this.state.renderedAwards}</Col>
          </Row>
      </>
    )
  }
}

export default props => (
  <StaticQuery
    query={graphql`
      query award_query {
        allMarkdownRemark(filter: {frontmatter: {conference_filter: {eq: true}}}) {
          edges {
            node {
              frontmatter {
                title
                number
                theme
                host
                dates
                program
                program_alt
                image
                awards{
                  award_title
                  winner_desc
                  winners{
                    contributor_name
                    contributor_location
                  }
                }
              }
            }
          }
        }
      }`}
    render={data => <AwardSelector data={data} {...props} />}
  />
)
